<template>
  <div>
    <v-card flat>
      <v-form @submit.prevent="sendSMS" v-model="isFormValid" ref="form">
        <v-card-text class="ml-4">Import Excel/CSV</v-card-text>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6
              ><v-card flat>
                <v-card-title>CSV</v-card-title>
                <v-card-text
                  ><v-alert
                    v-if="!csvFile"
                    text
                    prominent
                    color="primary"
                    icon="mdi-file-excel"
                    >Import CSV file (include "phone" column)
                  </v-alert>
                  <v-alert
                    v-else
                    text
                    prominent
                    type="primary"
                    icon="mdi-file-excel"
                    >{{ csvFileName }}
                  </v-alert>
                  <v-layout row class="mt-6">
                    <v-flex xs4 md3>
                      <v-tooltip top
                        ><template v-slot:activator="{ on, attrs }">
                          <input
                            type="file"
                            ref="fileInput"
                            style="display: none"
                            @change="handleFileChange"
                          />
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="cardTextAccent4 white--text lowercase-text"
                            block
                            plain
                            dark
                            @click="openFileInput"
                          >
                            <v-icon left>mdi-file</v-icon>
                            Import
                          </v-btn> </template
                        ><span>Import CSV file.</span></v-tooltip
                      >
                    </v-flex>
                    <v-flex xs3 md3 class="ml-4">
                      <v-tooltip top
                        ><template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="primary white--text lowercase-text"
                            block
                            plain
                            color="primary"
                            :loading="$store.state.loading.uploadCSVBtn.load"
                            :disabled="
                              $store.state.loading.uploadCSVBtn.disabled
                            "
                            @click="uploadFile"
                            ><v-icon left>mdi-upload</v-icon>Upload</v-btn
                          ></template
                        ><span>Upload to process file.</span></v-tooltip
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-text v-if="receivedFileRecords">
                  <div>Total contacts: [{{ receivedFileRecords.length }}]</div>
                  <div>File column(s):</div>
                  <div>
                    <v-chip
                      cols="4"
                      v-for="(key, index) in contactKeys"
                      :key="index"
                      class="ma-2"
                    >
                      {{ key }}
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card></v-flex
            >
            <v-flex xs12 md6
              ><v-card flat>
                <v-card-title>Compose SMS</v-card-title>

                <v-card-text>
                  <v-select
                    v-model="selectedTemplate"
                    :items="templateOptions"
                    label="Select a Template"
                    outlined
                    dense
                  ></v-select>
                  <v-textarea
                    v-model="selectedTemplateMessage"
                    :counter="300"
                    :rules="messageRules"
                    outlined
                    name="input-7-4"
                    label="Message"
                    placeholder="Type your message here (avoid emoji)."
                    dense
                  ></v-textarea>
                  <v-divider></v-divider>
                  <v-select
                    v-model="selectedSenderId"
                    class="mt-4"
                    :items="senderIdOptions"
                    label="--Select SenderID--"
                    outlined
                    dense
                    :rules="senderIdRules"
                  ></v-select>
                  <v-checkbox
                    v-model="checkbox"
                    label="Schedule this message"
                  ></v-checkbox>
                  <v-btn
                    v-if="!checkbox"
                    class="primary white--text lowercase-text"
                    plain
                    :loading="$store.state.loading.sendBtn.load"
                    :disabled="$store.state.loading.sendBtn.disabled"
                    type="submit"
                  >
                    Send Now
                  </v-btn>
                </v-card-text>
              </v-card></v-flex
            ></v-layout
          >
        </v-card-text>
      </v-form>
    </v-card>
    <DialogSchedule
      @close="checkbox = false"
      v-if="checkbox"
      :csvData="receivedFileRecords"
      :selectedTemplateMessage="selectedTemplateMessage"
      :selectedSenderId="selectedSenderId"
    />
  </div>
</template>

<script>
import DialogSchedule from "../Dialogs/ScheduleCsvDialog";
export default {
  props: ["templates", "senderIds"],
  components: { DialogSchedule },
  data: () => ({
    selectedTemplate: null,
    selectedTemplateMessage: "",
    selectedSenderId: null,
    senderIdRules: [(v) => !!v || "Sender ID is required"],
    isFormValid: false,
    phoneNumberRules: [(v) => !!v || "Phone number(s) is required"],
    messageRules: [
      (v) => !!v || "Message is required",
      (v) => v.length <= 300 || "Message must be 160 characters or fewer",
    ],
    checkbox: false,
    csvFileName: null,
    csvFile: null,
    receivedFileRecords: null,
  }),
  watch: {
    selectedTemplate() {
      // Clear customMessage when a template is selected
      const selectedTemplate = this.templates.find(
        (template) => template.name === this.selectedTemplate
      );
      this.selectedTemplateMessage = selectedTemplate
        ? selectedTemplate.message
        : "";
      this.customMessage = "";
    },
  },
  computed: {
    contactKeys() {
      // Extract the keys from the first contact object
      if (this.receivedFileRecords.length > 0) {
        return Object.keys(this.receivedFileRecords[0]);
      }
      return [];
    },
    templateOptions() {
      return this.templates.map((template) => template.name);
    },
    senderIdOptions() {
      return this.senderIds.map((sender) => sender.senderId);
    },
  },
  methods: {
    async sendSMS() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("send/sendCsvSMS", {
          csvData: this.receivedFileRecords,
          senderId: this.selectedSenderId,
          messageTemplate: this.selectedTemplateMessage,
        });
        this.selectedTemplateMessage = null;
      }
    },
    async uploadFile() {
      // Form is valid, perform form submission or other actions
      const formData = new FormData();
      formData.append("file", this.csvFile);

      // Send formData to your server or perform desired actions
      await this.$store.dispatch("csvs/uploadCSV", formData);

      this.receivedFileRecords = this.$store.getters["csvs/records"];
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      this.csvFileName = event.target.files[0].name;
      this.csvFile = event.target.files[0];
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
</style>
